"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const state_1 = __importDefault(require("../state"));
const getTilemap_1 = __importDefault(require("./definables/getTilemap"));
const getCootsScreenCoords = () => (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getScreenCoordsFromCoords(state_1.default.cootsCoords);
exports.default = getCootsScreenCoords;
